var _line, _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _path9, _g8, _path10, _g9, _path11, _g10, _path12, _g11, _path13, _g12, _path14, _g13, _path15, _g14, _path16, _g15, _path17, _g16, _path18, _g17, _path19, _g18, _path20, _path21, _g19, _path22, _g20, _path23, _g21, _path24, _g22, _path25, _g23, _path26, _g24, _path27, _g25, _path28, _g26, _path29, _g27, _path30, _g28, _path31, _g29, _path32, _g30, _path33, _g31, _path34, _g32, _path35, _g33, _path36, _g34, _path37, _g35, _path38, _g36, _path39, _path40, _g37, _path41, _g38, _path42, _g39, _path43, _g40, _path44, _g41, _path45, _g42, _path46, _g43, _path47, _g44, _path48, _g45, _path49, _g46, _path50, _g47, _path51, _g48, _path52, _g49, _path53, _g50, _path54, _g51, _path55, _g52, _path56, _path57, _g53, _path58, _g54, _path59, _g55, _path60, _g56, _path61, _g57, _path62, _g58, _path63, _g59, _path64, _g60, _path65, _g61, _path66, _g62, _path67, _g63, _path68, _g64, _path69, _g65, _path70, _g66, _path71, _g67, _path72, _g68, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoadmap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 670,
    viewBox: "0 0 82 670",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 77,
    x2: 42,
    y2: 610,
    stroke: "url(#paint0_linear_102_2)",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.0002 41.0001C82.0002 63.6477 63.6477 82.0002 41.0001 82.0002C18.3526 82.0002 0 63.6477 0 41.0001C0 18.3526 18.3526 0 41.0001 0C63.6345 0 82.0002 18.3526 82.0002 41.0001Z",
    fill: "#124F8A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 50,
    height: 50
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 16.7456H16.7324V65.2686H65.2554V16.7456Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.3462 32.4762C55.6768 31.1456 55.6768 28.9849 54.3462 27.6542C53.0155 26.3236 50.8548 26.3236 49.5242 27.6542C48.1935 28.9849 48.1935 31.1456 49.5242 32.4762C50.8548 33.8069 53.0155 33.8069 54.3462 32.4762Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 50,
    height: 50
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 16.7456H16.7324V65.2686H65.2554V16.7456Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.1094 30.0127L44.1221 30L44.1094 30.0127Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 50,
    height: 50
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 16.7456H16.7324V65.2686H65.2554V16.7456Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.1094 30.0128C41.9356 32.1867 42.8842 34.7689 45.058 36.9428C47.2319 39.1166 49.8141 40.0521 51.988 37.8914C52.7258 37.1404 52.9102 36.0469 52.515 35.1378C52.3174 34.6767 51.9089 34.3474 51.4215 34.2288C49.6165 33.8072 48.2068 32.3975 47.7852 30.5925C47.6666 30.105 47.3373 29.6966 46.8761 29.499C45.9539 29.0906 44.8604 29.2619 44.1094 30.0128Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 50,
    height: 50
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 16.7456H16.7324V65.2686H65.2554V16.7456Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6278 49.5375C26.2972 50.8682 26.2972 53.0289 27.6278 54.3595C28.9585 55.6902 31.1191 55.6902 32.4498 54.3595C33.7805 53.0289 33.7805 50.8682 32.4498 49.5375C31.1191 48.2069 28.9717 48.2069 27.6278 49.5375Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 50,
    height: 50
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 16.7456H16.7324V65.2686H65.2554V16.7456Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8644 52.0017C40.0383 49.8279 39.0897 47.2456 36.9158 45.0717C34.742 42.8979 32.1597 41.9625 29.9859 44.1232C29.2481 44.8741 29.0636 45.9676 29.4589 46.8767C29.6565 47.3378 30.0649 47.6672 30.5524 47.7858C32.3573 48.2074 33.767 49.6171 34.1886 51.422C34.3072 51.9095 34.6366 52.3179 35.0977 52.5155C36.0199 52.9239 37.1135 52.7527 37.8644 52.0017Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 50,
    height: 50
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 16.7456H16.7324V65.2686H65.2554V16.7456Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9863 44.1358L29.999 44.123L29.9863 44.1358Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 50,
    height: 50
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 16.7456H16.7324V65.2686H65.2554V16.7456Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5242 49.5375C48.1935 50.8682 48.1935 53.0289 49.5242 54.3595C50.8548 55.6902 53.0155 55.6902 54.3462 54.3595C55.6768 53.0289 55.6768 50.8682 54.3462 49.5375C53.0155 48.2069 50.8548 48.2069 49.5242 49.5375Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 50,
    height: 50
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 16.7456H16.7324V65.2686H65.2554V16.7456Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.4214 47.7856C51.9089 47.667 52.3173 47.3377 52.5149 46.8765C52.9102 45.9675 52.7389 44.874 51.9879 44.123C49.8141 41.9492 47.2318 42.8977 45.058 45.0716C42.8841 47.2454 41.9487 49.8277 44.1094 52.0016C44.8604 52.7393 45.9539 52.9238 46.8629 52.5286C47.324 52.3309 47.6534 51.9225 47.772 51.435C48.2068 49.6301 49.6165 48.2204 51.4214 47.7856Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 50,
    height: 50
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 16.7456H16.7324V65.2686H65.2554V16.7456Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4626 32.4762C33.7932 31.1456 33.7932 28.9849 32.4626 27.6542C31.1319 26.3236 28.9712 26.3236 27.6406 27.6542C26.3099 28.9849 26.3099 31.1456 27.6406 32.4762C28.9712 33.8069 31.1187 33.8069 32.4626 32.4762Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 50,
    height: 50
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 16.7456H16.7324V65.2686H65.2554V16.7456Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5654 34.2156C30.0779 34.3342 29.6695 34.6636 29.4719 35.1247C29.0766 36.0338 29.2479 37.1273 29.9989 37.8783C32.1727 40.0521 34.755 39.1035 36.9288 36.9297C39.1027 34.7558 40.0381 32.1735 37.8774 29.9997C37.1265 29.2619 36.033 29.0775 35.1239 29.4727C34.6628 29.6703 34.3334 30.0787 34.2148 30.5662C33.7801 32.3843 32.3704 33.794 30.5654 34.2156Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 50,
    height: 50
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 16.7456H16.7324V65.2686H65.2554V16.7456Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1448 37.5879C18.2608 37.5879 16.7325 39.1162 16.7325 41.0002C16.7325 42.8842 18.2608 44.4124 20.1448 44.4124C22.0288 44.4124 23.5571 42.8842 23.5571 41.0002C23.5439 39.1162 22.0288 37.5879 20.1448 37.5879Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 50,
    height: 50
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 16.7456H16.7324V65.2686H65.2554V16.7456Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8671 41.0007C29.8671 37.9309 28.7077 35.4409 25.6379 35.4277C24.5839 35.4277 23.6881 36.0865 23.3192 37.0087C23.1347 37.4698 23.1874 37.9968 23.4509 38.4316C24.4258 40.0126 24.4258 42.002 23.4509 43.5829C23.1874 44.0045 23.1347 44.5315 23.3192 45.0058C23.6881 45.9281 24.5839 46.5868 25.6379 46.5868C28.6945 46.5736 29.8671 44.0836 29.8671 41.0007Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 50,
    height: 50
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 16.7456H16.7324V65.2686H65.2554V16.7456Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9865 58.4443C39.1025 58.4443 37.5742 59.9726 37.5742 61.8566C37.5742 63.7406 39.1025 65.2689 40.9865 65.2689C42.8705 65.2689 44.3988 63.7406 44.3988 61.8566C44.3988 59.9726 42.8705 58.4443 40.9865 58.4443Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 50,
    height: 50
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 16.7456H16.7324V65.2686H65.2554V16.7456Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9875 52.1328C37.9178 52.1328 35.4277 53.2922 35.4277 56.3619C35.4277 57.4159 36.0865 58.3118 37.0087 58.6807C37.4698 58.8652 37.9968 58.8125 38.4316 58.549C40.0126 57.574 42.002 57.574 43.583 58.549C44.0046 58.8125 44.5316 58.8652 45.0059 58.6807C45.9281 58.3118 46.5868 57.4159 46.5868 56.3619C46.5605 53.2922 44.0704 52.1328 40.9875 52.1328Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 50,
    height: 50
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 16.7456H16.7324V65.2686H65.2554V16.7456Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9865 23.5707C42.8705 23.5707 44.3988 22.0424 44.3988 20.1584C44.3988 18.2744 42.8705 16.7461 40.9865 16.7461C39.1025 16.7461 37.5742 18.2744 37.5742 20.1584C37.5742 22.0424 39.1025 23.5707 40.9865 23.5707Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 50,
    height: 50
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 16.7456H16.7324V65.2686H65.2554V16.7456Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9875 29.8807C44.0572 29.8807 46.5473 28.7213 46.5605 25.6516C46.5605 24.5976 45.9017 23.7017 44.9795 23.3328C44.5184 23.1484 43.9914 23.2011 43.5566 23.4646C41.9756 24.4395 39.9862 24.4395 38.4052 23.4646C37.9836 23.2011 37.4566 23.1484 36.9824 23.3328C36.0601 23.7017 35.4014 24.5976 35.4014 25.6516C35.4277 28.7213 37.9178 29.8807 40.9875 29.8807Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 50,
    height: 50
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 16.7456H16.7324V65.2686H65.2554V16.7456Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.8428 37.5879C59.9587 37.5879 58.4305 39.1162 58.4305 41.0002C58.4305 42.8842 59.9587 44.4124 61.8428 44.4124C63.7268 44.4124 65.255 42.8842 65.255 41.0002C65.255 39.1162 63.7268 37.5879 61.8428 37.5879Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 50,
    height: 50
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 16.7456H16.7324V65.2686H65.2554V16.7456Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.5362 38.4316C58.7997 38.01 58.8524 37.483 58.668 37.0219C58.2991 36.0997 57.4032 35.4409 56.3492 35.4409C53.2795 35.4409 52.1201 37.931 52.1201 41.0007C52.1201 44.0704 53.2795 46.5605 56.3492 46.5737C57.4032 46.5737 58.2991 45.9149 58.668 44.9927C58.8524 44.5316 58.7997 44.0046 58.5362 43.5698C57.5613 42.002 57.5613 40.0126 58.5362 38.4316Z",
    fill: "white"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0002 433C82.0002 455.648 63.6477 474 41.0001 474C18.3526 474 0 455.648 0 433C0 410.353 18.3526 392 41.0001 392C63.6345 392 82.0002 410.353 82.0002 433Z",
    fill: "#00A3FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 408,
    width: 50,
    height: 50
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 408.746H16.7324V457.269H65.2554V408.746Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.3462 424.476C55.6768 423.146 55.6768 420.985 54.3462 419.654C53.0155 418.324 50.8548 418.324 49.5242 419.654C48.1935 420.985 48.1935 423.146 49.5242 424.476C50.8548 425.807 53.0155 425.807 54.3462 424.476Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 408,
    width: 50,
    height: 50
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 408.746H16.7324V457.269H65.2554V408.746Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.1094 422.013L44.1221 422L44.1094 422.013Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 408,
    width: 50,
    height: 50
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 408.746H16.7324V457.269H65.2554V408.746Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.1094 422.013C41.9356 424.187 42.8842 426.769 45.058 428.943C47.2319 431.117 49.8141 432.052 51.988 429.891C52.7258 429.14 52.9102 428.047 52.515 427.138C52.3174 426.677 51.9089 426.347 51.4215 426.229C49.6165 425.807 48.2068 424.397 47.7852 422.593C47.6666 422.105 47.3373 421.697 46.8761 421.499C45.9539 421.091 44.8604 421.262 44.1094 422.013Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 408,
    width: 50,
    height: 50
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 408.746H16.7324V457.269H65.2554V408.746Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6278 441.538C26.2972 442.868 26.2972 445.029 27.6278 446.36C28.9585 447.69 31.1191 447.69 32.4498 446.36C33.7805 445.029 33.7805 442.868 32.4498 441.538C31.1191 440.207 28.9717 440.207 27.6278 441.538Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 408,
    width: 50,
    height: 50
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 408.746H16.7324V457.269H65.2554V408.746Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8644 444.002C40.0383 441.828 39.0897 439.246 36.9158 437.072C34.742 434.898 32.1597 433.962 29.9859 436.123C29.2481 436.874 29.0636 437.968 29.4589 438.877C29.6565 439.338 30.0649 439.667 30.5524 439.786C32.3573 440.207 33.767 441.617 34.1886 443.422C34.3072 443.909 34.6366 444.318 35.0977 444.516C36.0199 444.924 37.1135 444.753 37.8644 444.002Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 408,
    width: 50,
    height: 50
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 408.746H16.7324V457.269H65.2554V408.746Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9863 436.136L29.999 436.123L29.9863 436.136Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 408,
    width: 50,
    height: 50
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 408.746H16.7324V457.269H65.2554V408.746Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5242 441.538C48.1935 442.868 48.1935 445.029 49.5242 446.36C50.8548 447.69 53.0155 447.69 54.3462 446.36C55.6768 445.029 55.6768 442.868 54.3462 441.538C53.0155 440.207 50.8548 440.207 49.5242 441.538Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 408,
    width: 50,
    height: 50
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 408.746H16.7324V457.269H65.2554V408.746Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.4214 439.786C51.9089 439.667 52.3173 439.338 52.5149 438.877C52.9102 437.967 52.7389 436.874 51.9879 436.123C49.8141 433.949 47.2318 434.898 45.058 437.072C42.8841 439.245 41.9487 441.828 44.1094 444.002C44.8604 444.739 45.9539 444.924 46.8629 444.529C47.324 444.331 47.6534 443.923 47.772 443.435C48.2068 441.63 49.6165 440.22 51.4214 439.786Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 408,
    width: 50,
    height: 50
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 408.746H16.7324V457.269H65.2554V408.746Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4626 424.476C33.7932 423.146 33.7932 420.985 32.4626 419.654C31.1319 418.324 28.9712 418.324 27.6406 419.654C26.3099 420.985 26.3099 423.146 27.6406 424.476C28.9712 425.807 31.1187 425.807 32.4626 424.476Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 408,
    width: 50,
    height: 50
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 408.746H16.7324V457.269H65.2554V408.746Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5654 426.216C30.0779 426.334 29.6695 426.664 29.4719 427.125C29.0766 428.034 29.2479 429.127 29.9989 429.878C32.1727 432.052 34.755 431.104 36.9288 428.93C39.1027 426.756 40.0381 424.174 37.8774 422C37.1265 421.262 36.033 421.077 35.1239 421.473C34.6628 421.67 34.3334 422.079 34.2148 422.566C33.7801 424.384 32.3704 425.794 30.5654 426.216Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 408,
    width: 50,
    height: 50
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 408.746H16.7324V457.269H65.2554V408.746Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1448 429.588C18.2608 429.588 16.7325 431.116 16.7325 433C16.7325 434.884 18.2608 436.412 20.1448 436.412C22.0288 436.412 23.5571 434.884 23.5571 433C23.5439 431.116 22.0288 429.588 20.1448 429.588Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 408,
    width: 50,
    height: 50
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 408.746H16.7324V457.269H65.2554V408.746Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8671 433.001C29.8671 429.931 28.7077 427.441 25.6379 427.428C24.5839 427.428 23.6881 428.086 23.3192 429.009C23.1347 429.47 23.1874 429.997 23.4509 430.432C24.4258 432.013 24.4258 434.002 23.4509 435.583C23.1874 436.005 23.1347 436.532 23.3192 437.006C23.6881 437.928 24.5839 438.587 25.6379 438.587C28.6945 438.574 29.8671 436.084 29.8671 433.001Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 408,
    width: 50,
    height: 50
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 408.746H16.7324V457.269H65.2554V408.746Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9865 450.444C39.1025 450.444 37.5742 451.973 37.5742 453.857C37.5742 455.741 39.1025 457.269 40.9865 457.269C42.8705 457.269 44.3988 455.741 44.3988 453.857C44.3988 451.973 42.8705 450.444 40.9865 450.444Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 408,
    width: 50,
    height: 50
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 408.746H16.7324V457.269H65.2554V408.746Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9875 444.133C37.9178 444.133 35.4277 445.292 35.4277 448.362C35.4277 449.416 36.0865 450.312 37.0087 450.681C37.4698 450.865 37.9968 450.812 38.4316 450.549C40.0126 449.574 42.002 449.574 43.583 450.549C44.0046 450.812 44.5316 450.865 45.0059 450.681C45.9281 450.312 46.5868 449.416 46.5868 448.362C46.5605 445.292 44.0704 444.133 40.9875 444.133Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 408,
    width: 50,
    height: 50
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 408.746H16.7324V457.269H65.2554V408.746Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9865 415.571C42.8705 415.571 44.3988 414.042 44.3988 412.158C44.3988 410.274 42.8705 408.746 40.9865 408.746C39.1025 408.746 37.5742 410.274 37.5742 412.158C37.5742 414.042 39.1025 415.571 40.9865 415.571Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 408,
    width: 50,
    height: 50
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 408.746H16.7324V457.269H65.2554V408.746Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9875 421.881C44.0572 421.881 46.5473 420.721 46.5605 417.652C46.5605 416.598 45.9017 415.702 44.9795 415.333C44.5184 415.148 43.9914 415.201 43.5566 415.465C41.9756 416.44 39.9862 416.44 38.4052 415.465C37.9836 415.201 37.4566 415.148 36.9824 415.333C36.0601 415.702 35.4014 416.598 35.4014 417.652C35.4277 420.721 37.9178 421.881 40.9875 421.881Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 408,
    width: 50,
    height: 50
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 408.746H16.7324V457.269H65.2554V408.746Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.8428 429.588C59.9587 429.588 58.4305 431.116 58.4305 433C58.4305 434.884 59.9587 436.412 61.8428 436.412C63.7268 436.412 65.255 434.884 65.255 433C65.255 431.116 63.7268 429.588 61.8428 429.588Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 408,
    width: 50,
    height: 50
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2554 408.746H16.7324V457.269H65.2554V408.746Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.5362 430.432C58.7997 430.01 58.8524 429.483 58.668 429.022C58.2991 428.1 57.4032 427.441 56.3492 427.441C53.2795 427.441 52.1201 429.931 52.1201 433.001C52.1201 436.07 53.2795 438.56 56.3492 438.574C57.4032 438.574 58.2991 437.915 58.668 436.993C58.8524 436.532 58.7997 436.005 58.5362 435.57C57.5613 434.002 57.5613 432.013 58.5362 430.432Z",
    fill: "white"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0002 237C82.0002 259.648 63.6477 278 41.0001 278C18.3526 278 0 259.648 0 237C0 214.353 18.3526 196 41.0001 196C63.6345 196 82.0002 214.353 82.0002 237Z",
    fill: "#0083FD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 218,
    width: 38,
    height: 38
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 218.106H22.1074V255.879H59.8928V218.106Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.4679 240.412C58.3519 240.412 59.8802 238.884 59.8802 237C59.8802 235.116 58.3519 233.587 56.4679 233.587C54.5839 233.587 53.0556 235.116 53.0556 237C53.0556 238.884 54.5839 240.412 56.4679 240.412Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 218,
    width: 38,
    height: 38
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 218.106H22.1074V255.879H59.8928V218.106Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.9868 231.44C47.9171 231.44 46.7577 233.93 46.7577 237C46.7577 240.07 47.9171 242.56 50.9868 242.573C52.0408 242.573 52.9367 241.914 53.3056 240.992C53.4901 240.531 53.4374 240.004 53.1739 239.582C52.1989 238.002 52.1989 236.012 53.1739 234.431C53.4374 234.01 53.4901 233.483 53.3056 233.021C52.9367 232.086 52.0276 231.44 50.9868 231.44Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 218,
    width: 38,
    height: 38
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 218.106H22.1074V255.879H59.8928V218.106Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5197 233.587C23.6357 233.587 22.1074 235.116 22.1074 237C22.1074 238.884 23.6357 240.412 25.5197 240.412C27.4037 240.412 28.932 238.884 28.932 237C28.932 235.116 27.4037 233.587 25.5197 233.587Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 218,
    width: 38,
    height: 38
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 218.106H22.1074V255.879H59.8928V218.106Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0002 242.573C34.07 242.573 35.2293 240.083 35.2293 237.013C35.2293 233.944 34.07 231.454 31.0002 231.44C29.9462 231.44 29.0503 232.099 28.6814 233.021C28.497 233.483 28.5497 234.01 28.8132 234.431C29.7881 236.012 29.7881 238.002 28.8132 239.582C28.5497 240.004 28.497 240.531 28.6814 240.992C29.0503 241.914 29.9594 242.573 31.0002 242.573Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 218,
    width: 38,
    height: 38
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 218.106H22.1074V255.879H59.8928V218.106Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9874 249.068C39.1034 249.068 37.5752 250.596 37.5752 252.48C37.5752 254.364 39.1034 255.892 40.9874 255.892C42.8714 255.892 44.3997 254.364 44.3997 252.48C44.3997 250.596 42.8714 249.068 40.9874 249.068Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 218,
    width: 38,
    height: 38
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 218.106H22.1074V255.879H59.8928V218.106Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5698 249.173C43.9914 249.436 44.5184 249.489 44.9927 249.305C45.9149 248.936 46.5736 248.04 46.5736 246.986C46.5736 243.916 44.0836 242.757 41.0007 242.757C37.9309 242.757 35.4409 243.916 35.4277 246.986C35.4277 248.04 36.0865 248.936 37.0087 249.305C37.4698 249.489 37.9968 249.436 38.4316 249.173C39.9994 248.198 41.9888 248.198 43.5698 249.173Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 218,
    width: 38,
    height: 38
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 218.106H22.1074V255.879H59.8928V218.106Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9874 224.931C42.8714 224.931 44.3997 223.403 44.3997 221.519C44.3997 219.635 42.8714 218.106 40.9874 218.106C39.1034 218.106 37.5752 219.635 37.5752 221.519C37.5883 223.403 39.1034 224.931 40.9874 224.931Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 218,
    width: 38,
    height: 38
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 218.106H22.1074V255.879H59.8928V218.106Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4184 224.826C37.9968 224.562 37.4698 224.51 37.0087 224.694C36.0865 225.063 35.4277 225.959 35.4277 227.013C35.4277 230.083 37.9178 231.242 40.9875 231.242C44.0572 231.242 46.5473 230.083 46.5605 227.013C46.5605 225.959 45.9017 225.063 44.9795 224.694C44.5183 224.51 43.9914 224.562 43.5566 224.826C41.9888 225.801 39.9994 225.801 38.4184 224.826Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 218,
    width: 38,
    height: 38
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 218.106H22.1074V255.879H59.8928V218.106Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6549 219.846C27.3243 218.515 25.1636 218.515 23.8329 219.846C22.5023 221.177 22.5023 223.337 23.8329 224.668C25.1636 225.999 27.3243 225.999 28.6549 224.668C29.9856 223.337 29.9856 221.177 28.6549 219.846Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 218,
    width: 38,
    height: 38
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 218.106H22.1074V255.879H59.8928V218.106Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1218 229.134C35.2956 226.96 36.231 224.378 34.0704 222.204C33.3194 221.466 32.2259 221.282 31.3168 221.677C30.8557 221.874 30.5263 222.283 30.4078 222.77C29.9862 224.575 28.5765 225.985 26.7715 226.407C26.2841 226.525 25.8756 226.855 25.678 227.316C25.2828 228.225 25.454 229.331 26.205 230.069C28.3657 232.243 30.9479 231.308 33.1218 229.134Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 218,
    width: 38,
    height: 38
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 218.106H22.1074V255.879H59.8928V218.106Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6549 249.331C27.3243 248 25.1636 248 23.8329 249.331C22.5023 250.662 22.5023 252.822 23.8329 254.153C25.1636 255.484 27.3243 255.484 28.6549 254.153C29.9856 252.822 29.9856 250.662 28.6549 249.331Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 218,
    width: 38,
    height: 38
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 218.106H22.1074V255.879H59.8928V218.106Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.122 244.878C30.9481 242.705 28.3659 241.769 26.192 243.93C25.4543 244.681 25.2698 245.774 25.6651 246.683C25.8627 247.144 26.2711 247.474 26.7586 247.592C28.5635 248.014 29.9732 249.424 30.3948 251.229C30.5134 251.716 30.8428 252.125 31.3039 252.322C32.213 252.717 33.3065 252.546 34.0574 251.795C36.2444 249.635 35.2958 247.039 33.122 244.878Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 218,
    width: 38,
    height: 38
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 218.106H22.1074V255.879H59.8928V218.106Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.332 224.668C54.6627 225.999 56.8233 225.999 58.154 224.668C59.4846 223.337 59.4846 221.177 58.154 219.846C56.8233 218.515 54.6627 218.515 53.332 219.846C51.9882 221.177 51.9882 223.337 53.332 224.668Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 218,
    width: 38,
    height: 38
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 218.106H22.1074V255.879H59.8928V218.106Z",
    fill: "white"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.8654 229.134C51.0393 231.308 53.6216 232.243 55.7954 230.083C56.5332 229.332 56.7176 228.238 56.3224 227.329C56.1248 226.868 55.7163 226.538 55.2289 226.42C53.4239 225.998 52.0142 224.589 51.5926 222.784C51.4741 222.296 51.1447 221.888 50.6836 221.69C49.7745 221.295 48.681 221.466 47.93 222.217C45.743 224.378 46.6916 226.96 48.8654 229.134Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 218,
    width: 38,
    height: 38
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 218.106H22.1074V255.879H59.8928V218.106Z",
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.154 249.331C56.8233 248 54.6627 248 53.332 249.331C52.0014 250.662 52.0014 252.822 53.332 254.153C54.6627 255.484 56.8233 255.484 58.154 254.153C59.4847 252.822 59.4847 250.662 58.154 249.331Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask51_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 218,
    width: 38,
    height: 38
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 218.106H22.1074V255.879H59.8928V218.106Z",
    fill: "white"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.2164 247.592C55.7039 247.474 56.1123 247.144 56.3099 246.683C56.7052 245.774 56.5339 244.681 55.7829 243.93C53.6091 241.756 51.0268 242.704 48.853 244.878C46.6791 247.052 45.7437 249.634 47.9044 251.808C48.6553 252.546 49.7488 252.73 50.6579 252.335C51.119 252.138 51.4484 251.729 51.567 251.242C52.0017 249.424 53.4115 248.014 55.2164 247.592Z",
    fill: "white"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0002 629C82.0002 651.648 63.6477 670 41.0001 670C18.3526 670 0 651.648 0 629C0 606.353 18.3526 588 41.0001 588C63.6345 588 82.0002 606.353 82.0002 629Z",
    fill: "#00C2FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 610,
    width: 38,
    height: 38
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 610.106H22.1074V647.879H59.8928V610.106Z",
    fill: "white"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.4679 632.412C58.3519 632.412 59.8802 630.884 59.8802 629C59.8802 627.116 58.3519 625.587 56.4679 625.587C54.5839 625.587 53.0556 627.116 53.0556 629C53.0556 630.884 54.5839 632.412 56.4679 632.412Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask53_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 610,
    width: 38,
    height: 38
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 610.106H22.1074V647.879H59.8928V610.106Z",
    fill: "white"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.9868 623.44C47.9171 623.44 46.7577 625.93 46.7577 629C46.7577 632.07 47.9171 634.56 50.9868 634.573C52.0408 634.573 52.9367 633.914 53.3056 632.992C53.4901 632.531 53.4374 632.004 53.1739 631.582C52.1989 630.002 52.1989 628.012 53.1739 626.431C53.4374 626.01 53.4901 625.483 53.3056 625.021C52.9367 624.086 52.0276 623.44 50.9868 623.44Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 610,
    width: 38,
    height: 38
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 610.106H22.1074V647.879H59.8928V610.106Z",
    fill: "white"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5197 625.587C23.6357 625.587 22.1074 627.116 22.1074 629C22.1074 630.884 23.6357 632.412 25.5197 632.412C27.4037 632.412 28.932 630.884 28.932 629C28.932 627.116 27.4037 625.587 25.5197 625.587Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask55_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 610,
    width: 38,
    height: 38
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 610.106H22.1074V647.879H59.8928V610.106Z",
    fill: "white"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0002 634.573C34.07 634.573 35.2293 632.083 35.2293 629.013C35.2293 625.944 34.07 623.454 31.0002 623.44C29.9462 623.44 29.0503 624.099 28.6814 625.021C28.497 625.483 28.5497 626.01 28.8132 626.431C29.7881 628.012 29.7881 630.002 28.8132 631.582C28.5497 632.004 28.497 632.531 28.6814 632.992C29.0503 633.914 29.9594 634.573 31.0002 634.573Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 610,
    width: 38,
    height: 38
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 610.106H22.1074V647.879H59.8928V610.106Z",
    fill: "white"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9874 641.068C39.1034 641.068 37.5752 642.596 37.5752 644.48C37.5752 646.364 39.1034 647.892 40.9874 647.892C42.8714 647.892 44.3997 646.364 44.3997 644.48C44.3997 642.596 42.8714 641.068 40.9874 641.068Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask57_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 610,
    width: 38,
    height: 38
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 610.106H22.1074V647.879H59.8928V610.106Z",
    fill: "white"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5698 641.173C43.9914 641.436 44.5184 641.489 44.9927 641.305C45.9149 640.936 46.5736 640.04 46.5736 638.986C46.5736 635.916 44.0836 634.757 41.0007 634.757C37.9309 634.757 35.4409 635.916 35.4277 638.986C35.4277 640.04 36.0865 640.936 37.0087 641.305C37.4698 641.489 37.9968 641.436 38.4316 641.173C39.9994 640.198 41.9888 640.198 43.5698 641.173Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask58_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 610,
    width: 38,
    height: 38
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 610.106H22.1074V647.879H59.8928V610.106Z",
    fill: "white"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9874 616.931C42.8714 616.931 44.3997 615.403 44.3997 613.519C44.3997 611.635 42.8714 610.106 40.9874 610.106C39.1034 610.106 37.5752 611.635 37.5752 613.519C37.5883 615.403 39.1034 616.931 40.9874 616.931Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask59_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 610,
    width: 38,
    height: 38
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 610.106H22.1074V647.879H59.8928V610.106Z",
    fill: "white"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4184 616.826C37.9968 616.562 37.4698 616.51 37.0087 616.694C36.0865 617.063 35.4277 617.959 35.4277 619.013C35.4277 622.083 37.9178 623.242 40.9875 623.242C44.0572 623.242 46.5473 622.083 46.5605 619.013C46.5605 617.959 45.9017 617.063 44.9795 616.694C44.5183 616.51 43.9914 616.562 43.5566 616.826C41.9888 617.801 39.9994 617.801 38.4184 616.826Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 610,
    width: 38,
    height: 38
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 610.106H22.1074V647.879H59.8928V610.106Z",
    fill: "white"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6549 611.846C27.3243 610.515 25.1636 610.515 23.8329 611.846C22.5023 613.177 22.5023 615.337 23.8329 616.668C25.1636 617.999 27.3243 617.999 28.6549 616.668C29.9856 615.337 29.9856 613.177 28.6549 611.846Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask61_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 610,
    width: 38,
    height: 38
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 610.106H22.1074V647.879H59.8928V610.106Z",
    fill: "white"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1218 621.134C35.2956 618.96 36.231 616.378 34.0704 614.204C33.3194 613.466 32.2259 613.282 31.3168 613.677C30.8557 613.874 30.5263 614.283 30.4078 614.77C29.9862 616.575 28.5765 617.985 26.7715 618.407C26.2841 618.525 25.8756 618.855 25.678 619.316C25.2828 620.225 25.454 621.331 26.205 622.069C28.3657 624.243 30.9479 623.308 33.1218 621.134Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask62_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 610,
    width: 38,
    height: 38
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 610.106H22.1074V647.879H59.8928V610.106Z",
    fill: "white"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6549 641.331C27.3243 640 25.1636 640 23.8329 641.331C22.5023 642.662 22.5023 644.822 23.8329 646.153C25.1636 647.484 27.3243 647.484 28.6549 646.153C29.9856 644.822 29.9856 642.662 28.6549 641.331Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask63_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 610,
    width: 38,
    height: 38
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 610.106H22.1074V647.879H59.8928V610.106Z",
    fill: "white"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.122 636.879C30.9481 634.705 28.3659 633.77 26.192 635.93C25.4543 636.681 25.2698 637.775 25.6651 638.684C25.8627 639.145 26.2711 639.474 26.7586 639.593C28.5635 640.014 29.9732 641.424 30.3948 643.229C30.5134 643.717 30.8428 644.125 31.3039 644.323C32.213 644.718 33.3065 644.547 34.0574 643.796C36.2444 641.635 35.2958 639.04 33.122 636.879Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask64_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 610,
    width: 38,
    height: 38
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 610.106H22.1074V647.879H59.8928V610.106Z",
    fill: "white"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.332 616.668C54.6627 617.999 56.8233 617.999 58.154 616.668C59.4846 615.337 59.4846 613.177 58.154 611.846C56.8233 610.515 54.6627 610.515 53.332 611.846C51.9882 613.177 51.9882 615.337 53.332 616.668Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask65_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 610,
    width: 38,
    height: 38
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 610.106H22.1074V647.879H59.8928V610.106Z",
    fill: "white"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.8654 621.134C51.0393 623.308 53.6216 624.243 55.7954 622.083C56.5332 621.332 56.7176 620.238 56.3224 619.329C56.1248 618.868 55.7163 618.538 55.2289 618.42C53.4239 617.998 52.0142 616.589 51.5926 614.784C51.4741 614.296 51.1447 613.888 50.6836 613.69C49.7745 613.295 48.681 613.466 47.93 614.217C45.743 616.378 46.6916 618.96 48.8654 621.134Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask66_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 610,
    width: 38,
    height: 38
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 610.106H22.1074V647.879H59.8928V610.106Z",
    fill: "white"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.154 641.331C56.8233 640 54.6627 640 53.332 641.331C52.0014 642.662 52.0014 644.822 53.332 646.153C54.6627 647.484 56.8233 647.484 58.154 646.153C59.4847 644.822 59.4847 642.662 58.154 641.331Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask67_102_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 610,
    width: 38,
    height: 38
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 610.106H22.1074V647.879H59.8928V610.106Z",
    fill: "white"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.2164 639.593C55.7039 639.474 56.1123 639.145 56.3099 638.684C56.7052 637.775 56.5339 636.681 55.7829 635.93C53.6091 633.756 51.0268 634.705 48.853 636.879C46.6791 639.053 45.7437 641.635 47.9044 643.809C48.6553 644.546 49.7488 644.731 50.6579 644.336C51.119 644.138 51.4484 643.73 51.567 643.242C52.0017 641.424 53.4115 640.014 55.2164 639.593Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_102_2",
    x1: 41,
    y1: 617.5,
    x2: 41,
    y2: 90.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#00A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#0081FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004F8E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmap);
export default __webpack_public_path__ + "static/media/roadmap.52089b006704d5279f73fc115cf80a29.svg";
export { ForwardRef as ReactComponent };